<div class="toaster position-fixed top-0 right-0 px-3 py-2 m-16">
    <div *ngFor="let notify of currentNotifications; index as i">
        <app-notification
            [type]="notify.type"
            [title]="notify.title"
            [message]="notify.message"
            (disposeEvent)="dispose(i)"
        ></app-notification>
    </div>
</div>